export const sortTreatmentByLatest = (treatments) => {
  const sortByLatest = (a, b) => b.isLatest - a.isLatest;
  // const compareTreatmentEndDate = (a, b) => new Date(b.treatment_end_date) - new Date(a.treatment_end_date);
  const compareTreatmentEndDate = (a, b) => new Date(b.date_of_adding) - new Date(a.date_of_adding);
  return [...treatments].sort(compareTreatmentEndDate).sort(sortByLatest);
};
